(function menuScript(Drupal) {
  Drupal.behaviors.menu = {
    attach: function (context, settings) {
      context = context || document;
      const menuItems = Array.from(context.querySelectorAll('li.menu-item--level-0'));

      function handleMenuItemHover(menuItem) {
        const subMenuToggle = menuItem.querySelector('.menu__sub-menu-toggle');
        if (!subMenuToggle) return;
        const subMenu = subMenuToggle.nextElementSibling;

        // Ensure the submenu toggle is visible
        subMenuToggle.removeAttribute('hidden');
        subMenuToggle.style.display = 'inline-block'; // Ensure toggle (arrow) is visible

        // Show the submenu when hovering over the parent menu item
        menuItem.addEventListener('mouseenter', function () {
          subMenu.style.display = 'block';
          subMenuToggle.setAttribute('aria-expanded', 'true');
          subMenuToggle.classList.add('menu__sub-menu-toggle--hover'); // Add hover class for styling or animation
        });

        // Keep the submenu open if hovering over the submenu itself
        subMenu.addEventListener('mouseenter', function () {
          subMenu.style.display = 'block';
          subMenuToggle.setAttribute('aria-expanded', 'true');
          subMenuToggle.classList.add('menu__sub-menu-toggle--hover');
        });

        // Hide submenu only if the mouse leaves both the menu item and submenu
        menuItem.addEventListener('mouseleave', function () {
          setTimeout(function () {
            if (!menuItem.querySelector(':hover') && !subMenu.querySelector(':hover')) {
              subMenu.style.display = 'none';
              subMenuToggle.setAttribute('aria-expanded', 'false');
              subMenuToggle.classList.remove('menu__sub-menu-toggle--hover');
            }
          }, 100);
        });

        subMenu.addEventListener('mouseleave', function () {
          setTimeout(function () {
            if (!menuItem.querySelector(':hover') && !subMenu.querySelector(':hover')) {
              subMenu.style.display = 'none';
              subMenuToggle.setAttribute('aria-expanded', 'false');
              subMenuToggle.classList.remove('menu__sub-menu-toggle--hover');
            }
          }, 100);
        });

        // Show submenu when button receives focus (for keyboard accessibility)
        subMenuToggle.addEventListener('focus', function () {
          subMenu.style.display = 'block';
          subMenuToggle.setAttribute('aria-expanded', 'true');
        });

        // Hide submenu when focus is lost (for keyboard accessibility)
        subMenuToggle.addEventListener('blur', function () {
          setTimeout(function () {
            if (!menuItem.contains(document.activeElement)) {
              subMenuToggle.setAttribute('aria-expanded', 'false');
              subMenu.style.display = 'none';
            }
          }, 100);
        });

        // Escape key, outside click, and tabbing behavior
        window.addEventListener("keyup", function (e) {
          if (e.code === "Escape") {
            subMenuToggle.setAttribute('aria-expanded', 'false');
            subMenu.style.display = 'none';
            subMenuToggle.focus();
          }
        });

        window.addEventListener("click", function (e) {
          if (!subMenu.contains(e.target) && !subMenuToggle.contains(e.target)) {
            subMenuToggle.setAttribute('aria-expanded', 'false');
            subMenu.style.display = 'none';
          }
        });

        window.addEventListener("keydown", function (e) {
          if (e.code === "Tab") {
            const focused = document.activeElement;
            if (!subMenu.contains(focused) && !subMenuToggle.contains(focused)) {
              subMenuToggle.setAttribute('aria-expanded', 'false');
              subMenu.style.display = 'none';
            }
          }
        });
      }

      // Attach hover events to each top-level menu item
      menuItems.forEach(handleMenuItemHover);
    },
  };
})(Drupal);
